interface ConfigProps {
  BASE_URL: string;
  STORAGE_KEY: string;
  ASSET_PATH: string;
  CLOUDFLARE_SITE_KEY: string;
  DEFAULT_IMG: string;
  DEFAULT_PRODUCT_IMG: string;
}

const Config = (): ConfigProps => {
  return {
    CLOUDFLARE_SITE_KEY: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
    BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:3000/api",
    STORAGE_KEY: process.env.REACT_APP_STORAGE_KEY || "itopup-customer@2025",
    ASSET_PATH: process.env.REACT_APP_PUBLIC || "/",
    DEFAULT_IMG: `${process.env.PUBLIC_URL}/imgs/no-image.jpeg`,
    DEFAULT_PRODUCT_IMG: `${process.env.PUBLIC_URL}/imgs/no-product-image.jpg`,
  };
};

export default Config();
